// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sales-container-ZIv0T {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0 32px 20px;
}

.sales-toolbar-DpGS5 {
  height: 52px;
  align-items: center;
}

.sales-title_title-qHOw7 {
  font-size: var(--text-lg);
}

.sales-content-byUpJ {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 20px;
  margin-top: 0px;
}

.sales-contentDisabled-lASNl {
  pointer-events: none;
  opacity: 0.70;
}

.sales-metricsRow-vnQB4 {
  display: flex;
  gap: 20px;
  overflow: auto;
}

.sales-chartsContainer-yv4YG {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 20px;
}

.sales-topCharts-vi3R3 {
  display: flex;
  gap: 20px;
  flex: 1;
}

.sales-bottomChart-zHeUW {
  display: flex;
  flex: 1;
}

.sales-chartCard-CfQLC {
  flex: 1;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.sales-chartCardloading-DKuWK {
  background-color: var(--color-neutral-50);
  animation: sales-pulse-XPnIN 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.sales-chartCardloading-DKuWK > * {
  visibility: hidden;
}

@keyframes sales-pulse-XPnIN {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.sales-chartTitle-lnw2E {
  color: var(--color-neutral-800);
  font-size: var(--text-base);
  font-weight: var(--font-weight-medium);
}

.sales-chartPlaceholder-KORry {
  flex: 1;
  background-color: var(--color-neutral-50);
  border: 1px dashed var(--color-neutral-200);
  border-radius: var(--radius-2xl);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-neutral-400);
  font-size: 13px;
}

.sales-empty-HhWlc {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  color: var(--color-neutral-500);
}

.sales-error-JlkmC {
  height: 100%;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/sales/sales.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,OAAO;AACT;;AAEA;EACE,aAAa;EACb,OAAO;AACT;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yCAAyC;EACzC,qEAAyD;AAC3D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,OAAO;EACP,yCAAyC;EACzC,2CAA2C;EAC3C,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding: 0 32px 20px;\n}\n\n.toolbar {\n  height: 52px;\n  align-items: center;\n}\n\n.title_title {\n  font-size: var(--text-lg);\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  gap: 20px;\n  margin-top: 0px;\n}\n\n.contentDisabled {\n  pointer-events: none;\n  opacity: 0.70;\n}\n\n.metricsRow {\n  display: flex;\n  gap: 20px;\n  overflow: auto;\n}\n\n.chartsContainer {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  gap: 20px;\n}\n\n.topCharts {\n  display: flex;\n  gap: 20px;\n  flex: 1;\n}\n\n.bottomChart {\n  display: flex;\n  flex: 1;\n}\n\n.chartCard {\n  flex: 1;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.chartCardloading {\n  background-color: var(--color-neutral-50);\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n.chartCardloading > * {\n  visibility: hidden;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n.chartTitle {\n  color: var(--color-neutral-800);\n  font-size: var(--text-base);\n  font-weight: var(--font-weight-medium);\n}\n\n.chartPlaceholder {\n  flex: 1;\n  background-color: var(--color-neutral-50);\n  border: 1px dashed var(--color-neutral-200);\n  border-radius: var(--radius-2xl);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-neutral-400);\n  font-size: 13px;\n}\n\n.empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n  color: var(--color-neutral-500);\n}\n\n.error {\n  height: 100%;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `sales-container-ZIv0T`,
	"toolbar": `sales-toolbar-DpGS5`,
	"title_title": `sales-title_title-qHOw7`,
	"content": `sales-content-byUpJ`,
	"contentDisabled": `sales-contentDisabled-lASNl`,
	"metricsRow": `sales-metricsRow-vnQB4`,
	"chartsContainer": `sales-chartsContainer-yv4YG`,
	"topCharts": `sales-topCharts-vi3R3`,
	"bottomChart": `sales-bottomChart-zHeUW`,
	"chartCard": `sales-chartCard-CfQLC`,
	"chartCardloading": `sales-chartCardloading-DKuWK`,
	"pulse": `sales-pulse-XPnIN`,
	"chartTitle": `sales-chartTitle-lnw2E`,
	"chartPlaceholder": `sales-chartPlaceholder-KORry`,
	"empty": `sales-empty-HhWlc`,
	"error": `sales-error-JlkmC`
};
export default ___CSS_LOADER_EXPORT___;
